export default "__VITE_ASSET__7H98apsm__"